module.exports = {
	"purchase_type": {
		"digital_document_basis": "Selvbetjening",
		"digital_document_review": "Juridisk tjek",
		"digital_document_advice": "Udvidet rådgivning",
		"registration": "Tinglysning",
		"upgrade_to_review": "Opgradering til juridisk tjek",
		"upgrade_to_advice": "Opgradering til udvidet rådgivning",
		"description": {
			"digital_document_basis": "Når du køber Selvbetjening, får du fuld adgang til dokumentet og alle relaterede funktioner. Du får adgang til at se og hente dit dokument, og vi guider dig hele vejen til det er juridisk gyldigt",
			"digital_document_advice": "Når du køber Udvidet rådgivning, har du adgang til alle de samme funktioner som ved køb af Selvbetjening. Du kan derudover booke et telefonisk rådgivningsmøde hvor en jurist giver dig konktet rådgivning om dine ønsker og behov."
		}
	},
	"products": {
		"*": "Valgfrit dokument",
		"values_database": "Mine værdier",
		"favored": "Begunstigelseserklæring",
		"beneficiary": "Begunstigelseserklæring",
		"child_support_agreement": "Aftale om forhøjet børnebidrag",
		"coop": "Samejekontrakt",
		"deed_property": "Skøde, Bolig",
		"deed_divorce": "Skøde, Skilsmisse",
		"restricted_deed_of_gift": "Gavebrev",
		"deed_of_gift": "Gavebrev",
		"future_pow": "Fremtidsfuldmagt",
		"inheritance_advance": "Arveforskud",
		"inheritance_waiver": "Arveafkald",
		"pow": "Fuldmagt",
		"prenup": "Ægtepagt",
		"prenuptial_exit": "Ophævelse af særeje",
		"prenuptial_pension": "Pensionsægtepagt",
		"promissory_note": "Gældsbrev",
		"property_division_agreement": "Bodelingsoverenskomst",
		"spousal_support_agreement": "Aftale om ægtefællebidrag",
		"togetherness_agreement": "Aftale om samvær",
		"undivided_estate_agreement": "Samtykkeerklæring",
		"will": "Testamente",
		"will_contents": "Indbotestamente",
		"will_child": "Børnetestamente",
		"guidance": "Juridisk rådgivning",
		"existing_document": "Eksisterende dokument",
		"buyer_advice": "Køberrådgivning",
		"rectification": "Berigtigelse",
		"follow_up_processing": "Eftersagsbehandling",
		"family_transfer": "Familieoverdragelse",
		"codicil": "Kodicil",
		"meeting_no_show": "Manglende fremmøde",
		"document_send": "Udsendelse af dokument",
		"registration1": "1. Tinglysning",
		"registration2": "2. Tinglysning",
		"application_to_agriculture_agency": "Ansøgning til Langbrugsstyrelsen",
		"application_to_civil_agency": "Ansøgning til Civilstyrelsen",
		"debitor_shift": "Debitorskifte",
		"family_trade": "Familiehandel",
		"price_negotiation": "Prisforhandling",
		"private_trade": "Privathandel",
		"transfer_agreement": "Overdragelsesaftale",
		"probate_certificate": "Skifteretsattest",
		"screening_family_transfer": "Screeningsmøde - Familieoverdragelse",
		"package_2_future_pow": "2 x Fremtidsfuldmagt",
		"package_2_general_pow": "2 x Fuldmagt",
		"package_will_review_2_future_pow": "Testamente m. Juridisk tjek & 2 x Fremtidsfuldmagter",
		"package_will_advice_2_future_pow": "Testamente m. Rådgivning & 2 x Fremtidsfuldmagt",
		"package_will_advice_2_future_pow_marriage_contract": "Testamente m. Rådgivning & 2 x Fremtidsfuldmagt & Ægtepagt",
		"package_will_advice_2_future_pow_pension_contract": "Testamente m. Rådgivning & 2 x Fremtidsfuldmagt & Pensionsægtepagt",
		"package_will_advice_2_future_pow_coownership_contract": "Testamente m. Rådgivning & 2 x Fremtidsfuldmagt & Samejekontrakt",
		"package_will_advice_2_future_pow_unsplit_estate_consent": "Testamente m. Rådgivning & 2 x Fremtidsfuldmagt & Samtykke til uskiftet bo"
	},
	"products_specific": {
		"favored": "begunstigelseserklæringen",
		"beneficiary": "begunstigelseserklæringen",
		"child_support_agreement": "aftalen om forhøjet børnebidrag",
		"coop": "samejekontrakten",
		"deed_property": "skøde, bolig",
		"deed_divorce": "skøde, skilsmisse",
		"deed_of_gift": "gavebrevet",
		"future_pow": "fremtidsfuldmagten",
		"inheritance_advance": "arveforskudet",
		"inheritance_waiver": "arveafkaldet",
		"pow": "fuldmagten",
		"prenup": "ægtepagten",
		"prenuptial_exit": "ophævelsen af særeje",
		"prenuptial_pension": "pensionægtepagten",
		"promissory_note": "gældsbrevet",
		"property_division_agreement": "bodelingsoverenskomsten",
		"spousal_support_agreement": "aftalen om ægtefællebidrag",
		"togetherness_agreement": "aftalen om samvær",
		"undivided_estate_agreement": "samtykkeerklæringen",
		"will": "testamentet",
		"will_contents": "indbotestamentet",
		"will_child": "børnetestamentet",
		"probate_certificate": "skifteretsattest"
	},
	"conditions": {
		"title": "Regler og betingelser",
		"title_updated": "Vi har opdateret vores betingelser",
		"required": "Du skal acceptere vores regler og betingelser, før du kan bruge TestaViva",
		"failed": "Der skete en fejl og vi kunne ikke gemme din accept. Prøv venligst igen eller kontakt support@testaviva.dk",
		"decline": "afvis",
		"accept": "Accepter",
		"checkbox": {
			"prefix": "Jeg accepterer ",
			"suffix": "regler og betingelser"
		}
	},
	"misc": {
		"answer": "Svar",
		"video": "Video",
		"arrow_down": "Pil ned",
		"next": "Næste",
		"previous": "Forrige",
		"loading": "Henter",
		"play": "Afspil video",
		"back": "Tilbage",
		"choose": "Vælg",
		"ok": "OK",
		"accepted": "Accepteret",
		"not_accepted": "Ikke accepteret",
		"thanks": "Tak",
		"no": "Nej",
		"yes": "Ja",
		"url": "Webside"
	},
	"user": {
		"authenticate": {
			"dashboard": "Gå til mit dashboard",
			"user": "Bruger",
			"title": "Log ind",
			"email": "E-mail",
			"password": "Adgangskode",
			"forgot": "Har du glemt dit kodeord?",
			"non_existing": "Har du ikke en profil?",
			"create": "Opret profil",
			"errors": {
				"email": "Din email er ikke gyldig",
				"empty_all": "Du skal udfylde alle felterne",
				"email_pass": "Din e-mail eller kodeord er forkert"
			}
		},
		"banner": {
			"benefits": "Mere info"
		},
		"create": {
			"button": "Opret bruger",
			"existing": "Allerede medlem? ",
			"authenticate": "Log ind",
			"back": "Tilbage",
			"name": "Dit navn",
			"phone": "Dit telefonnummer",
			"phone_hint": "Hvis vi får brug for at kontakte dig i forbindelse med dine juridiske dokumenter",
			"email": "Din email",
			"password": "Adgangskode",
			"password_repeat": "Gentag kodeord",
			"password_repeat_hint": "Mindst seks tegn, store og små bogstaver plus ét tegn og ét tal",
			"conditions": "Jeg accepterer <a href=\"https://testaviva.dk/vilkaar\" target=\"_blank\">regler og betingelser</a>",
			"marketing": "Jeg giver samtykke til, at TestaViva kan kontakte mig pr. e-mail, SMS eller telefonisk angående fordelene ved TestaVivas juridiske dokumenter samt vejlede mig bedst muligt i denne forbindelse. Jeg er opmærksom på, at jeg til enhver tid kan trække mit samtykke tilbage på Min Profil på TestaViva.dk.",
			"errors": {
				"empty": "Dette felt må ikke stå tomt",
				"empty_all": "Du skal udfylde alle felterne",
				"email_pass": "Din e-mail eller kodeord er forkert",
				"name": "Du skal indtaste dit fornavn og efternavn",
				"phone": "Dit telefon nummer er ikke gyldigt",
				"email": "Din email er ikke gyldig",
				"password": "Dit kodeord skal være på min. 6 tegn og indeholde min. ét tal og ét bogstav",
				"password_equal": "Dine kodeord er ikke ens",
				"conditions": "Du skal acceptere vores regler og betingelser",
				"unknown": "Der skete en ukendt fejl. Prøv venligst igen, eller kontakt TestaViva."
			}
		}
	},
	"sidemenu": {
		"faq": "Spørgsmål",
		"contact": "Kontakt",
		"call": "Ring mig op",
		"meeting": "Book møde",
		"title": "HJÆLP?"
	},
	"call_me_modal": {
		"title": "Bliv ringet op af TestaViva",
		"description": "Har du spørgsmål eller brug for hjælp? Skriv dit telefonnummer nedenfor, og vælg hvilken type rådgivning, du har brug for. Vi ringer dig op, så hurtigt vi kan.",
		"help": "Hvis du ønsker et juridisk tjek af din(e) juridiske dokument(er), ",
		"help_link": "så tryk her.",
		"phone": "Dit telefonnummer",
		"input": "Telefon nummer",
		"button": "Ring mig op",
		"phoneError": "Det indtastede telefon nummer er ikke gyldigt.",
		"reasonError": "Du mangler at vælge, hvilket emne du ønsker at snakke om.",
		"successMessage": "Du vil blive ringet op af TestaViva hurtigst muligt.",
		"errorMessage": "Det skete en fejl. Kontakt support@testaviva.dk hvis fejlen fortsætter.",
		"ticket": {
			"title": "En bruger ønsker at blive ringet op.",
			"content": "Brugeren med telefon nummer {phone}, ønsker at blive ringet op. Brugeren har spørgsmål til: {topic}."
		},
		"reason": {
			"title": "Vælg et emne",
			"legal": "Juridiske spørgsmål",
			"platform": "Spørgsmål til platformen",
			"lecture": "Ønske om foredrag",
			"other": "Andet"
		},
		"confirm": "Tak! Du vil blive ringet op hurtigst muligt.",
		"confirm_button": "OK"
	},
	"bookMeeting": {
		"continue": "Fortsæt",
		"back": "Tilbage",
		"success": "Du har nu booket udvidet juridisk rådgivning med en af vores jurister, og vil blive ringet op d. {datetime}.",
		"error": "Der skete en fejl. Kontakt support@testaviva.dk hvis fejlen fortsætter.",
		"maxProduct": "Du kan vælge op til 6 produkter pr. juridiske rådgivning.<br /> Ønsker du at booke en juridisk rådgivning med flere produkter, bedes du kontakte os på 88 62 60 50.",
		"phone": {
			"invalid": "Du skal indtaste et gyldigt telefon nummer",
			"errorSave": "Der skete en fejl da vi prøvede at gemme telefonnummeret. Prøv igen, eller henvend dig til support@testaviva.dk."
		},
		"process": {
			"chooseProduct": "Vælg produkt(er)",
			"chooseTimeDate": "Vælg dato/tid",
			"choosePartners": "Vælg partnere",
			"seePriceAndConfirm": "Se priser og book"
		},
		"selectProduct": {
			"title": {
				"digital_document_basis": "Hvilke produkter ønsker du at købe?",
				"digital_document_advice": "Hvilke produkter ønsker du rådgivning til?"
			},
			"digitalProducts": "Digitale produkter",
			"nonDigitalProducts": "Ikke-digitale produkter"
		},
		"selectDateTime": {
			"title": "Hvilken dag og tid ønsker du rådgivning?",
			"selectDateTitle": "Vælg dato",
			"selectTimeTitle": "Vælg tidspunkt",
			"noAvailableTimes": "Kunne ikke hente ledige tidspunkter. Prøv at genindlæse siden, eller henvend dig til vores support.",
			"noAvailableTimesOnDay": "Der er desværre ingen ledige tidspunkter på den valgte dato. Vælg en anden dato, for at se ledige tidspunkter."
		},
		"selectPhone": {
			"title": "Indtast det nummer vi skal ringe dig op på"
		},
		"selectPartners": {
			"title": "Er du kunde hos nogle af vores partnere?",
			"continueWithoutPartners": "Fortsæt uden partnere",
			"subTitle": "Vælg hvor du er partner"
		},
		"confirmBooking": {
			"title": "Her er din pris",
			"totalPrice": "Total",
			"create": {
				"digital_document_basis": "Opret bruger og betal",
				"digital_document_advice": "Opret bruger og book"
			},
			"login": {
				"digital_document_basis": "Log ind og betal",
				"digital_document_advice": "Log ind og book"
			},
			"book": {
				"digital_document_basis": "Betal for produkt",
				"digital_document_advice": "Book udvidet juridisk rådgivning"
			}
		}
	},
	"newUserForm": {
		"continue": "Fortsæt",
		"buttons": {
			"accept": "Godkend",
			"decline": "Afvis",
			"create": "Opret bruger",
			"login": "Log ind på TestaViva"
		},
		"titles": {
			"name": "Indtast dit fulde navn",
			"phone": "Indtast dit telefon nummer",
			"email": "Indtast din e-mail.",
			"password": "Indtast dit kodeord",
			"confirmPassword": "Gentag dit kodeord",
			"terms": "<span>Jeg accepterer TestaVivas <a href=\"/vilkaar\" target=\"_blank\">regler og betingelser</a></span>",
			"news": "Jeg giver samtykke til, at TestaViva kan kontakte mig pr. e-mail, SMS eller telefonisk angående fordelene ved TestaVivas juridiske dokumenter samt vejlede mig bedst muligt i denne forbindelse. Jeg er opmærksom på, at jeg til enhver tid kan trække mit samtykke tilbage på Min Profil på TestaViva.dk."
		},
		"error": {
			"emptyField": "Dette felt må ikke stå tomt.",
			"confirmPassword": "Dine kodeord er ikke ens.",
			"phone": "Dit telefon nummer er ikke gyldigt.",
			"email": "Din email er ikke gyldig.",
			"name": "Du skal indtaste dit fornavn og efternavn.",
			"terms": "Du skal acceptere vores regler og betingelser.",
			"password": "Dit kodeord skal være på min. 6 tegn og indeholde min. ét tal og ét bogstav."
		}
	},
	"months": {
		"january": "Januar",
		"february": "Februar",
		"march": "Marts",
		"april": "April",
		"may": "Maj",
		"june": "Juni",
		"july": "Juli",
		"august": "August",
		"september": "September",
		"october": "Oktober",
		"november": "November",
		"december": "December"
	},
	"weekday": {
		"short": {
			"monday": "Man",
			"tuesday": "Tir",
			"wednesday": "Ons",
			"thursday": "Tor",
			"friday": "Fre",
			"saturday": "Lør",
			"sunday": "Søn"
		}
	},
	"article_slider": {
		"articles_about": "Artikler om",
		"articles_read": "Læs artiklen"
	},
	"price_service": {
		"how_to": "Hvordan gør jeg?",
		"show_services": "Hvad får jeg?",
		"advice": "Juridisk rådgivning {amount},-",
		"digital": "Selvbetjening {amount},-",
		"advice_only": "Dette dokument kan kun oprettes med juridisk rådgivning",
		"choose": "Vælg din service",
		"purchase": "Køb",
		"view": "Se produkt",
		"error": "Du skal vælge en service du vil købe."
	},
	"purchase_sidebar": {
		"title": "Dit køb",
		"advantages": "Kundefordel",
		"sub_total": "Sub-total",
		"total": "Total",
		"discount": "Rabat",
		"empty": "Din kurv er tom",
		"cta": "Gå til betaling",
		"add_to_basket": "Tilføj til køb"
	},
	"tickets": {
		"menu": "Hjælp",
		"title": "Har du et spørgsmål til TestaViva kan du indsende det her",
		"description": "Bemærk at hvis spørgsmålet er af juridisk karakter, skal du købe udvidet juridisk rådgivning.",
		"subject": "Titel",
		"subjectError": "Du skal udfylde en titel",
		"subjectPlaceholder": "Beskriv kort hvad spørgsmålet drejer sig om.",
		"message": "Spørgsmål",
		"messageError": "Du skal skrive en besked",
		"messagePlaceholder": "Skriv så uddybende som muligt, så vores support har de bedste vilkår for at svare så præcist som muligt på spørgsmålet.",
		"submit": "Send",
		"couldNotCreate": "Vi kunne ikke oprette din henvendelse i vores support system. Fejlen er indrapporteret. For at få hjælp, bedes du skrive til support@testaviva.dk. Vi beklager besværet!",
		"created": "Dit spørgsmål er blevet indsendt og du modtager en bekræftelse på din e-mail. Når vi har svaret på din besked, modtager du en e-mail. Vi svarer indenfor to hverdage."
	},
	"utils": {
		"delete": "Slet"
	},
	"errors": {
		"generic": "Der skete en uventet fejl. Prøv igen, eller kontakt vores support på 88 62 60 50",
		"failed_to_save_document": "Kunne ikke gemme dokumentet. Prøv at genindlæse siden og hvis fejlen stadig opstår, kontakt venligst support@testaviva.dk.",
		"failed_to_load_document": "Kunne ikke hente dit dokument. Prøv at genindlæse siden og hvis fejlen stadig opstår, kontakt venligst support@testaviva.dk."
	}
};